import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MlFeatureSet, MlFeatureSetCreate, MlFeatureSetFilter } from '../data/mlFeatureSet';

export function createMlFeatureSetService(client: AxiosInstance) {
  return createCrudService<MlFeatureSet, MlFeatureSetCreate, MlFeatureSetFilter>(
    client,
    '/ai/MlFeatureSet',
    'id',
  );
}

export type MlFeatureSetService = CrudService<MlFeatureSet, MlFeatureSetCreate, MlFeatureSetFilter>;
